/*
 * Copyright (c) 2022. Revo Digital
 * ---
 * Author: gabriele
 * File: RichTextEditorOverlay.tsx
 * Project: mle-client-n
 * Committed last: 2022/2/9 @ 1742
 * ---
 * Description:
 */

import { observer }               from 'mobx-react';
import { Editor }                 from '../../store/observables/Editor';
import { Card, Classes, Overlay } from '@blueprintjs/core';
import classNames                 from 'classnames';
import { currentThemeIsDark }     from '../../common/utils';
import { CenterBothAxes }         from '../common/layout/CenterBothAxes';
import React, { useCallback }     from 'react';
import { RichTextEditor }         from '../editor/editors/RichTextEditor';

interface Props {
  editor: Editor;
  isOpen: boolean;
  onClose: () => void;
  setter: (content: string) => void;
  initialValue?: string;
  closeButton?: boolean;
}

export const RichTextEditorOverlay = observer((props: Props) => {

  const handleClose = useCallback(() => {
    props.onClose();
  }, []);

  return (
    <Overlay isOpen={ props.isOpen } usePortal enforceFocus
             className={ classNames(Classes.OVERLAY_SCROLL_CONTAINER,
               { 'bp4-dark': currentThemeIsDark() }) }>
      <CenterBothAxes>
        <Card className="mle-center-both-axes-child mx-auto min-w-max">
          <div className="bp4-text-muted mle-info-heading">
            Testo multistile
          </div>
          <RichTextEditor editor={ props.editor } setter={ props.setter }
                          initialValue={ props.initialValue }
                          disableExit={ props.closeButton }
                          onExit={ handleClose }/>
        </Card>
      </CenterBothAxes>
    </Overlay>
  );
});
